import React from 'react';
import { ProgressIndicator } from '@getgo/chameleon-material-ui';
import { Box } from '@material-ui/core';

export const CenteredLoadingSpinner = () => (
  <Box display="flex" justifyContent="center" alignItems="center" flexGrow="1">
    <ProgressIndicator variant="circular" />
  </Box>
);
